<mat-dialog-content>
  {{data.message | async}}@if (data.message) {
  <span>&nbsp;<b>{{data.itemName}}</b></span>
  }?
  <p>{{data.message2 | async}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button [mat-dialog-close]="false" type="button" id="no" mat-flat-button>{{'No' | translate}}</button>
  <button [mat-dialog-close]="true" type="button" id="yes" mat-flat-button color="warn">{{'Yes' | translate}}</button>
</mat-dialog-actions>
